exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".operations-data-page[data-v-68ac3c54]{padding:0.13333rem}", ""]);

// exports
